<template>
  <a
    class="header-cart site-header__toggle"
    :href="cartlink"
  >
    <span
      v-if="ordertype == 'offer'"
      class="header-cart__price"
      :class="{'header-cart__price--not-empty': subtotal > 0}"
    >Tarjous
      <span
        v-if="subtotal > 0"
        class="header-cart__price-amount"
      >WC-{{ offerId }}</span>
      <span
        v-if="subtotal > 0"
        class="header-cart__tax tax"
      ><price
        :price-with-tax="subTotalWithTax"
        :price-without-tax="subTotalWithoutTax"
      /></span>
    </span>
    <span
      v-else
      class="header-cart__price"
      :class="{'header-cart__price--not-empty': subtotal > 0}"
    >{{ $modeoL10n.cart }}
      <span
        v-if="subtotal > 0"
        class="header-cart__price-amount"
      >
        <price
          :price-with-tax="subTotalWithTax"
          :price-without-tax="subTotalWithoutTax"
        />
      </span>
      <span
        v-if="subtotal > 0"
        class="header-cart__tax tax"
      >{{ $modeoL10n.vat }} {{ $store.getters.displayVat }}</span>
    </span>
    <span class="header-cart__amount">
      <template v-if="items > 0">{{ items }}</template><template v-else>&nbsp;</template>
    </span>
    <span class="site-header__toggle__text">{{ $modeoL10n.cart }}</span>
  </a>
</template>

<script>
    import axios from 'axios';

    export default {
        props: {
            offerId: {
                type: String,
                default: '',
            },
            cartlink: {
                type: String,
                default: '',
            },
            nonce: {
                type: String,
                default: '',
            },
            ordertype: {
                type: String,
                default: '',
            },
            userIsLoggedIn: Boolean,
        },
        computed: {
            items: function () {
                return this.$store.getters.getTotals.count;
            },
            subTotalWithTax: function(){
                const totals = this.$store.getters.getTotals;
                return this.parseCommaDecimalFormat(totals.subtotal) + this.parseCommaDecimalFormat(totals.subtotalTax);
            },
            subTotalWithoutTax: function() {
                const totals = this.$store.getters.getTotals;
                return this.parseCommaDecimalFormat( totals.subtotal )
            },
            subtotal: function () {
                const showPricesWithVat = this.$store.getters.showPricesWithVat;
                return (showPricesWithVat) ? this.subTotalWithTax : this.subTotalWithoutTax;
            },
        },
        created: function () {
            /** update cart on init */
            this.updateCartIfNeeded();

        },
        methods: {
            setTotals : function(subtotal, subtotalTax, total, discount, discountTax, count) {
                let totals = {
                    subtotal: subtotal,
                    subtotalTax: subtotalTax,
                    total: total,
                    discount: discount,
                    discountTax: discountTax,
                    count: count,
                };
                this.$store.commit('setTotals', totals);
            },

            updateCartIfNeeded : function() {
                let cartHash = this.getCookie('woocommerce_cart_hash');
                let userHasCart = typeof cartHash !== 'undefined';
                if (userHasCart || this.userIsLoggedIn) {
                    this.updateCart();
                }
            },

            updateCart : function() {
                let config = {
                    headers: {
                        'X-WP-Nonce': this.nonce,
                    },
                }

                //Get total & total items
                let langSuffix = this.$modeoL10n.multilang == '1' ? '?lang=' + this.$modeoL10n.lang : '';
                axios.get(`/wp-json/modeo/v2/cart/cart_total` + langSuffix, config)
                .then(response => {
                    this.setTotals(response.data.subtotal, response.data.subtotal_tax, response.data.total, response.data.discount_total, response.data.discount_tax, response.data.cart_product_count);
                    this.$store.commit('setShippingMethods', response.data.shipping_methods);
                    this.$store.commit('setCoupons', response.data.coupons);
                })
                .catch(e => {
                    console.error( e );
                    //Handle errors here if needed...
                });

            },

            getCookie : function (name) {
                let value = "; " + document.cookie;
                let parts = value.split("; " + name + "=");
                if (parts.length == 2) {
                    return parts.pop().split(";").shift();
                }
            },
        },
    }
</script>
